export default {
  jobNumber: 'Číslo zákazky',
  loaded: 'Načítané',
  process: 'Receptúra',
  processStartTime: 'Čas spustenia procesu',
  stageName: 'Názov fázy',
  stageNumber: 'Číslo fázy',
  stageTime: 'Čas fázy',
  status: 'Stav',
  systemName: 'Názov systému',
};
